import { vec3 } from 'gl-matrix'
import GLArrayBuffer from 'nanogl/arraybuffer'
import Program from 'nanogl/program'
import Texture2D from 'nanogl/texture-2d'
import { GLContext } from 'nanogl/types'
import GLState, { LocalConfig } from 'nanogl-state/GLState'

import { HexToNewVec3 } from '@/webgl/core/Color'
import { RenderContext } from '@/webgl/core/RenderContext'
import RenderMask from '@/webgl/core/RenderMask'
import Programs from '@/webgl/glsl/programs'

export default class ScreenSpiralRenderer {
  reveal: number = 0
  time: number = 1
  rotate: boolean = true
  offsetX: number = 0
  offsetY: number = 0
  fsPlane: GLArrayBuffer
  prg: Program
  cfg: LocalConfig

  color1: vec3 = HexToNewVec3(0x02475f)
  color2: vec3 = HexToNewVec3(0x002938)

  private texture: Texture2D

  constructor(readonly gl: GLContext) {
    this.prg = Programs(gl).get('flash-spiral')

    const fsData = new Float32Array([0, 0, 1, 0, 0, 1, 1, 1])
    this.fsPlane = new GLArrayBuffer(gl, fsData)
    this.fsPlane.attrib('aTexCoord0', 2, gl.FLOAT)

    this.cfg = GLState.get(gl).config()
    this.cfg.enableBlend(true).blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA).enableDepthTest(false)
  }

  setTexture(texture: Texture2D) {
    this.texture = texture
  }

  render(context: RenderContext) {
    if ((context.mask & RenderMask.BLENDED) == 0) return

    this.prg.use()

    const bw = this.gl.drawingBufferWidth
    const bh = this.gl.drawingBufferHeight
    const max = Math.max(bw, bh)

    this.prg.uColor1(this.color1)
    this.prg.uColor2(this.color2)
    this.prg.uFlash(this.reveal, this.time)
    this.prg.uTransform(this.offsetX, this.offsetY, bw / max, bh / max)
    this.prg.tSpiral(this.texture)
    this.prg.uRotation(this.rotate ? 1 : 0)

    this.cfg.apply()
    this.fsPlane.bind()
    this.fsPlane.attribPointer(this.prg)
    this.fsPlane.drawTriangleStrip()
  }
}
